jQuery(document).ready(function ($) {
  	if($('.header .promo').length>0) {
      var promoheight = $('.header .promo').outerHeight();
      $('main#MainContent').css('margin-top',promoheight);
      $('.header .promo span.promo-close').click(function() {
        $('.header .promo').remove();
        $('main#MainContent').css('margin-top',0);
      });
    }
  	if($('body.wishlist-page').length > 0 || $('body.login').length > 0 || $('body.register').length > 0 || $('body.account').length > 0 || $('body.order').length > 0 || $('body.addresses').length > 0 || $('body.reset_password').length > 0 || $('body.search').length > 0 || $('body.product').length > 0 || $('body.cart').length > 0 || $('body.404').length > 0 || $('body.template-page').length > 0)
    {
    	$('body').addClass('page-no-banner');
    }
  
  	if($(window).width() < 768){
      checkMenumobile(0);
      function checkMenumobile(c) {
        setTimeout(() => {
            $('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').click(function() {
              $('body').addClass('menu-mobile-opened');
              //console.log('menu open');
            });
            if ($('.header .header__inline-menu .ets_mm_embeddedcode.open').length) {
          		$('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').click(function() {
              		$('body').addClass('menu-mobile-opened');
                  	//console.log('menu open');
                });
            }
            else { 
              checkMenumobile(c + 1);
              $('.header .header__inline-menu .ets_mm_embeddedcode .ets-item-header-mobile').click(function() {
              		$('body').removeClass('menu-mobile-opened');
                  	//console.log('menu close');
                });
            };
        }, 1000);
      }
  	  $('.header .header__inline-menu .menu-overlay').click(function() {
        $(this).parent().find('.ets_mm_embeddedcode').removeClass('open');
        $(this).parent().find('.ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').removeClass('open');
  	  	$('body').removeClass('menu-mobile-opened');
        //console.log('menu close 2');
      });
	}
    
	setTimeout(() => {
  		if($(window).outerWidth() > 767) {
  		  //console.log($(window).outerWidth());
          $('.header .header__inline-menu .ets_mm_embeddedcode').removeClass('mm-mobile');
          $('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').addClass('ets-mm-hidden');
          $('.header .header__inline-menu .list-menus .menu-item').mouseover(function() {
          	$(this).addClass('open');
          });
          $('.header .header__inline-menu .list-menus .menu-item').mouseleave(function() {
          	$(this).removeClass('open');
          });
		}
    }, 1000);

// 	setTimeout(() => {
//     	if($('body.template-index').length > 0)
//     	{
//         	$('.ets_mm_embeddedcode ul li:nth-child(3)').addClass('active');
//     	}
// 		else if($('body.template-page-about-us').length > 0) {
//         	$('.ets_mm_embeddedcode ul li:nth-child(4)').addClass('active');
// 		}
// 		else if($('body.template-page-education').length > 0) {
//         	$('.ets_mm_embeddedcode ul li:nth-child(8)').addClass('active');
// 		}
// 	}, 4000);
// 	setTimeout(function () {
//           var path = window.location.href;
//            $('.ets_mm_embeddedcode .list-menus .menu-item .menu-item-link').each(function() {
//             if (this.href === path) {
//              $(this).parent().parent().addClass('active');
//             }
//            });
//       		$('.ets_mm_embeddedcode .menu-item .list-columns ul.block-collection li a').each(function() {
//               if (this.href === path) {
//                 $(this).parents(8).addClass('active');
//               }
//            });
//     }, 1000);
  
    $(window).resize(function(){
		if($('.header .promo').length>0) {
      		$('main#MainContent').css('margin-top',$('.header .promo').outerHeight());
    	}
		// $('.page-no-banner main#MainContent').css('padding-top',$('.header .header-container').outerHeight());
  		if($(window).width() < 768){
          checkMenumobile(0);
          function checkMenumobile(c) {
              setTimeout(() => {
                $('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').click(function() {
                  $('body').addClass('menu-mobile-opened');
                });
                if ($('.header .header__inline-menu .ets_mm_embeddedcode.open').length) {
                  $('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').click(function() {
                    $('body').addClass('menu-mobile-opened');
                  });
                }
                else { 
                  checkMenumobile(c + 1);
                  $('.header .header__inline-menu .ets_mm_embeddedcode .ets-item-header-mobile').click(function() {
                    $('body').removeClass('menu-mobile-opened');
                  });
                };
              }, 1000);
          }
          $('.header .header__inline-menu .menu-overlay').click(function() {
            $(this).parent().find('.ets_mm_embeddedcode').removeClass('open');
            $(this).parent().find('.ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').removeClass('open');
            $('body').removeClass('menu-mobile-opened');
          });
        }
        setTimeout(() => {
            if($(window).outerWidth() > 767) {
              $('.header .header__inline-menu .ets_mm_embeddedcode').removeClass('mm-mobile');
              $('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').addClass('ets-mm-hidden');
              $('.header .header__inline-menu .list-menus .menu-item').mouseover(function() {
                $(this).addClass('open');
              });
              $('.header .header__inline-menu .list-menus .menu-item').mouseleave(function() {
                $(this).removeClass('open');
              });
            }
        }, 1000);
	});
});
jQuery(window).on('load', function(){
  	if(jQuery('.header .promo').length>0) {
      var promoheight = jQuery('.header .promo').outerHeight();
      jQuery('main#MainContent').css('margin-top',promoheight);
    }
	// jQuery('.page-no-banner main#MainContent').css('padding-top',jQuery('.header .header-container').outerHeight());
	setTimeout(() => {
  		if(jQuery(window).outerWidth() > 767) {
          jQuery('.header .header__inline-menu .ets_mm_embeddedcode').removeClass('mm-mobile');
          jQuery('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').addClass('ets-mm-hidden');
		  jQuery('.header .header__inline-menu .list-menus .menu-item').mouseover(function() {
          	jQuery(this).addClass('open');
          });
          jQuery('.header .header__inline-menu .list-menus .menu-item').mouseleave(function() {
          	jQuery(this).removeClass('open');
          });
    	}
    }, 1000);
	setTimeout(function () { 
    	var path = window.location.href;
        jQuery('.ets_mm_embeddedcode .list-menus .menu-item .menu-item-link').each(function() {
        	if (this.href === path) {
          		jQuery(this).parent().parent().addClass('active');
        	}
        });
      	jQuery('.ets_mm_embeddedcode .menu-item .list-columns ul.block-collection li a').each(function() {
              if (this.href === path) {
                jQuery(this).parents(8).addClass('active');
              }
           });
    }, 1000);
});

jQuery(window).change(function(){
  	if(jQuery('.header .promo').length>0) {
      var promoheight = jQuery('.header .promo').outerHeight();
      jQuery('main#MainContent').css('margin-top',promoheight);
    }
	// jQuery('.page-no-banner main#MainContent').css('padding-top',jQuery('.header .header-container').outerHeight());
	
  	if(jQuery(window).width() < 768){
          checkMenumobile(0);
          function checkMenumobile(c) {
              setTimeout(() => {
                jQuery('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').click(function() {
                  jQuery('body').addClass('menu-mobile-opened');
                });
                if (jQuery('.header .header__inline-menu .ets_mm_embeddedcode.open').length) {
                  jQuery('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').click(function() {
                    jQuery('body').addClass('menu-mobile-opened');
                  });
                }
                else { 
                  checkMenumobile(c + 1);
                  jQuery('.header .header__inline-menu .ets_mm_embeddedcode .ets-item-header-mobile').click(function() {
                    jQuery('body').removeClass('menu-mobile-opened');
                  });
                };
              }, 1000);
          }
          jQuery('.header .header__inline-menu .menu-overlay').click(function() {
            jQuery(this).parent().find('.ets_mm_embeddedcode').removeClass('open');
            jQuery(this).parent().find('.ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').removeClass('open');
            jQuery('body').removeClass('menu-mobile-opened');
          });
    }
});
jQuery(window).on('orientationchange', function(){
  	if(jQuery('.header .promo').length>0) {
      var promoheight = jQuery('.header .promo').outerHeight();
      jQuery('main#MainContent').css('margin-top',promoheight);
    }
	// jQuery('.page-no-banner main#MainContent').css('padding-top',jQuery('.header .header-container').outerHeight());
	if(jQuery(window).width() < 768){
          checkMenumobile(0);
          function checkMenumobile(c) {
              setTimeout(() => {
                jQuery('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').click(function() {
                  jQuery('body').addClass('menu-mobile-opened');
                });
                if (jQuery('.header .header__inline-menu .ets_mm_embeddedcode.open').length) {
                  jQuery('.header .header__inline-menu .ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').click(function() {
                    jQuery('body').addClass('menu-mobile-opened');
                  });
                }
                else { 
                  checkMenumobile(c + 1);
                  jQuery('.header .header__inline-menu .ets_mm_embeddedcode .ets-item-header-mobile').click(function() {
                    jQuery('body').removeClass('menu-mobile-opened');
                  });
                };
              }, 1000);
          }
          jQuery('.header .header__inline-menu .menu-overlay').click(function() {
            jQuery(this).parent().find('.ets_mm_embeddedcode').removeClass('open');
            jQuery(this).parent().find('.ets_mm_embeddedcode .ets-mm-toggle-menu-mobile').removeClass('open');
            jQuery('body').removeClass('menu-mobile-opened');
          });
    }
});